const ModalSectionHeader = ({ title }: { title: string }) => {
    return <h6 className="text-left font_caption_s text-on_surface_variant_dark">{title}</h6>; 
}

export default ModalSectionHeader   
